import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { KidsComponent } from './kids.component';
import { KidsHomeComponent } from './components/home/kids-home.component';
import { KidsAttachedComponent } from './components/attached/kids-attached.component';
import { KidsRankingComponent } from './components/ranking/list/kids-ranking.component';
import { KidsRankingClassifComponent } from './components/ranking/classification/kids-ranking-classif.component';
import { SharedAttachmentsDetailComponent } from '@theme/components';

const routes: Routes = [
    {
        path: '',
        component: KidsComponent,
        children: [
            { path: 'home', component: KidsHomeComponent },
            {
                path: 'tournament',
                loadChildren: () => import('../tournament/tournament.module').then((m) => m.TournamentModule),
            },
            { path: 'ranking-2', loadChildren: () => import('../ranking/ranking.module').then((m) => m.RankingModule) },
            { path: 'ranking', component: KidsRankingComponent },
            {
                path: 'ranking-classif/:rankingId',
                component: KidsRankingClassifComponent,
            },
            {
                path: 'attached/:sessionType',
                component: KidsAttachedComponent,
            },
            { path: 'attached/:sessionType/detail/:docId', component: SharedAttachmentsDetailComponent },
        ],
    },
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
})
export class KidsRoutingModule {}
